import {
    format,
    formatDistanceToNowStrict,
    isToday,
    isThisYear,
    startOfDay,
  } from "date-fns";
  
  export const categorizeDeeds = (deeds) => {
    const groupedDeeds = {};
  
    deeds.forEach((deed) => {
      const deedDate = new Date(deed.dateTime);
      const formattedDate = startOfDay(deedDate); // to round off time to the day
  
      if (groupedDeeds[formattedDate]) {
        groupedDeeds[formattedDate].push(deed);
      } else {
        groupedDeeds[formattedDate] = [deed];
      }
    });
  
    // Sort deeds within each card by date (newest to oldest)
    for (const date in groupedDeeds) {
      groupedDeeds[date].sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));
    }
  
    return groupedDeeds;
  };
  
  export const formatRelativeDate = (date) => {
    if (isToday(date)) {
      return 'Today';
    } else if (isThisYear(date)) {
      // If the date is within this year, exlcude year
      return format(date, 'EEE MMM d');
    } else {
      // For dates beyond this week, return the full date
      return format(date, 'EEE MMM d, yyyy');
    }
  };
  
  export const formatDistanceCustom = (date) => {
    const distance = formatDistanceToNowStrict(date, { addSuffix: false });
    const parts = distance.split(" ");
    const value = parts[0];
    let unit = parts[1].charAt(0);
    if (parts[1] === 'months') unit = 'mo';
    return value + unit;
  };
  